import React from 'react';
import PropTypes from 'prop-types';

import Autosuggest from "react-autosuggest";

function ProductGeneralAutosuggest ({addTag, clearSuggestions = () => {}, ...props}) {

    const handleOnChange = (e, {method}) => {
        if (method === 'enter') {
            e.preventDefault();
        } else {
            props.onChange(e);
        }
    };

    const renderSuggestion = (suggestion => {
        if (!suggestion || !suggestion[props.nameColumn]) {
            return <span>Aucune suggestion</span>;
        }

        if(props.pillColumns) {
            return (
                <div style={{ padding: '4px 0' }}>
                    <div style={{
                        fontWeight: '600',
                        color: '#2c3e50',
                        marginBottom: '4px',
                        fontSize: '14px'
                    }}>
                        {suggestion[props.nameColumn]}
                    </div>
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '6px',
                        marginTop: '4px'
                    }}>
                        {props.pillColumns.map((col, index) => {
                            const value = suggestion[col];
                            if (!value) return null;
                            return (
                                <span
                                    key={index}
                                    style={{
                                        borderRadius: '12px',
                                        backgroundColor: '#e3f2fd',
                                        color: '#1976d2',
                                        padding: '3px 10px',
                                        fontSize: '11px',
                                        fontWeight: '500',
                                        border: '1px solid #bbdefb'
                                    }}
                                >
                                    {value}
                                </span>
                            );
                        })}
                    </div>
                </div>
            );
        }
        return <span>{suggestion[props.nameColumn]} <span></span></span>;
    });

    let inputProps = {...props};
    delete inputProps.suggestions;
    delete inputProps.clearSuggestions;
    delete inputProps.getSuggestions;
    delete inputProps.formControl;
    delete inputProps.pillColumns;
    delete inputProps.nameColumn;
    delete inputProps.ref;
    if(props.formControl) {
        inputProps.className = "form-control";
    }

    return (
        <Autosuggest
            theme={theme}
            ref={props.ref}
            suggestions={props.suggestions || []}
            shouldRenderSuggestions={(value) => value && value.trim().length >= 1}
            getSuggestionValue={(suggestion) => suggestion[props.nameColumn] || ''}
            renderSuggestion={renderSuggestion}
            inputProps={{...inputProps, onChange: handleOnChange}}
            onSuggestionSelected={(e, {suggestion}) => addTag(suggestion[props.nameColumn])}
            onSuggestionsClearRequested={() => clearSuggestions()}
            onSuggestionsFetchRequested={({ value }) => {
                if (value && value.trim().length >= 1) {
                    props.getSuggestions(value);
                }
            }}
        />
    )
}

ProductGeneralAutosuggest.propTypes = {
    addTag: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    clearSuggestions: PropTypes.func,
    getSuggestions: PropTypes.func.isRequired,

    nameColumn: PropTypes.string.isRequired,
    pillColumns: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.string.isRequired,
    formControl: PropTypes.bool,
    placeholder: PropTypes.string.isRequired,
    style: PropTypes.object,
    suggestions: PropTypes.array.isRequired,
    ref: PropTypes.object,
};


const theme = {
    suggestionsContainer: {
        position: "absolute",
        left: "0",
        zIndex: "1000",
        background: "white",
        width: "100%",
        marginLeft: "15px",
        padding: "0",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        marginTop: "4px",
        maxHeight: "400px",
        overflowY: "auto"
    },

    suggestionsList: {
        listStyleType: "none",
        padding: "8px",
        margin: "0",
        width: "100%"
    },

    suggestion: {
        listStyleType: "none",
        width: "100%",
        margin: "0",
        cursor: "pointer",
        padding: "10px 12px",
        borderRadius: "6px",
        transition: "all 0.2s ease",
        marginBottom: "4px"
    },

    suggestionHighlighted: {
        background: "#f5f5f5",
        transform: "translateX(4px)"
    }
};

export default ProductGeneralAutosuggest;